import { ICommunicationState } from './types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const NS = 'communicationSlice';

const initialState: ICommunicationState = {
  emailEnabled: false,
  smsEnabled: false,
};

const communicationSlice = createSlice({
  name: 'communication', // used in action types
  initialState,
  reducers: {
    reset: () => {
      return initialState;
    },
    setEmailEnabled: (state: ICommunicationState, action: PayloadAction<boolean>) => {
      state.emailEnabled = action.payload;
    },
    setSmsEnabled: (state: ICommunicationState, action: PayloadAction<boolean>) => {
      state.smsEnabled = action.payload;
    },
  },
  extraReducers: (builder) => {
    // builder
    //   .addCase(loadTags.pending, (state, action) => {
    //     state.status = FetchingStatus.loading;
    //   })
  },
});

// Extract the action creators object and the reducer
const { actions, reducer } = communicationSlice;
// Extract and export each action creator by name
export { actions as communicationActions };
// Export the reducer, either as a default or named export
export default reducer;
